import { FC } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from '../layout'
// import Dashboard from '../Pages/Dashboard/Dashboard';
import { USER_ROLES } from '../all-types'
import { useAppSelector } from '../redux-store/hooks'
import {
  AppDownloadPage,
  AppLauncher,
  BarcodeScanner,
  BillCounterHome,
  BillingHistory,
  Category,
  ClientLogin,
  Dashboard,
  Inventory,
  KitchenStats,
  KitchenTabsScreen,
  LayoutSettings,
  LoginScreen,
  Settings,
  UserManagement,
} from '../screens'
import { KitchenTabsAdmin } from '../screens/admin-kitchen-screen'
import { BillingInTabs } from '../screens/billing/billing-in-tabs'
import Business from '../screens/Business/Business'
import { Printer } from '../screens/printer'
import { Welcome } from '../screens/welcome'
import DashboardPrivateRoute from './dashboard-route'

interface ComponentProps {
  isLoaderActive: boolean
  toggleTheme: () => void
  increaseFontSize: () => void
  decreaseFontSize: () => void
  canIncreaseFontSize: boolean
  canDecreaseFontSize: boolean
  selectedServerUrl: string | null
  onServerChange: (serverUrl: string) => void
}

const AppRoutes: FC<ComponentProps> = ({
  isLoaderActive,
  toggleTheme,
  increaseFontSize,
  decreaseFontSize,
  canIncreaseFontSize,
  canDecreaseFontSize,
  selectedServerUrl,
  onServerChange,
}) => {
  const auth = useAppSelector((state) => state.authentication);
  localStorage.setItem("ruchi_role", auth.role || "")
  const ROLE = auth.role
  //const isLoggedIn = auth.token !== null || auth.token !== undefined || auth?.token !== ""

  if (ROLE === USER_ROLES.ADMIN || ROLE === USER_ROLES.MANAGER) {
    return (
      <Routes>
        <Route path="/clientlogin" element={<ClientLogin />} />
        <Route
          path="/login"
          element={
            <LoginScreen
              selectedServerUrl={selectedServerUrl}
              onServerChange={onServerChange}
            />
          }
        />
        <Route
          path="/app"
          element={
            <DashboardPrivateRoute
              isLoaderActive={isLoaderActive}
              toggleTheme={toggleTheme}
              increaseFontSize={increaseFontSize}
              decreaseFontSize={decreaseFontSize}
              canIncreaseFontSize={canIncreaseFontSize}
              canDecreaseFontSize={canDecreaseFontSize}
              selectedServerUrl={selectedServerUrl}
              onServerChange={onServerChange}
            >
              <Layout
                isLoaderActive={isLoaderActive}
                toggleTheme={toggleTheme}
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                canIncreaseFontSize={canIncreaseFontSize}
                canDecreaseFontSize={canDecreaseFontSize}
                selectedServerUrl={selectedServerUrl}
                onServerChange={onServerChange}
              />
            </DashboardPrivateRoute>
          }
        >
          <Route index element={<AppLauncher />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="settings" element={<Settings />} />
          <Route path="layout" element={<LayoutSettings />} />
          <Route path="order" element={<BillingInTabs />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="category" element={<Category />} />
          <Route path="business" element={<Business />} />
          <Route path="counter" element={<BillCounterHome />} />
          <Route path="history" element={<BillingHistory />} />
          <Route path="kitchen" element={<KitchenTabsScreen />} />
          <Route path="admin-kitchen" element={<KitchenTabsAdmin />} />
          <Route path="download" element={<AppDownloadPage />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="kitchen-stats" element={<KitchenStats />} />

          {/* <Route path="reports" element={<Items handleOpen={() => console.log("test")} />} /> */}
        </Route>
        <Route path="/services" element={<Welcome />} />
        <Route path="/barcode" element={<BarcodeScanner />} />

        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>
    )
  }

  // if (ROLE === USER_ROLES.CASHIER || ROLE === USER_ROLES.MANAGER) {
  //   return (
  //     <Routes>
  //       <Route path="/clientlogin" element={<ClientLogin />} />
  //       <Route path="/login" element={<LoginScreen />} />
  //       <Route
  //         path="/app"
  //         element={
  //           <DashboardPrivateRoute
  //             isLoaderActive={isLoaderActive}
  //             toggleTheme={toggleTheme}
  //           >
  //             <Layout
  //               isLoaderActive={isLoaderActive}
  //               toggleTheme={toggleTheme}
  //             />
  //           </DashboardPrivateRoute>
  //         }
  //       >
  //         <Route index element={<AppDownloadPage />} />
  //         <Route path="counter" element={<BillCounterHome />} />
  //         <Route path="inventory" element={<Inventory />} />
  //         <Route path="category" element={<Category />} />
  //         <Route path="kitchen" element={<KitchenTabsScreen />} />
  //       </Route>

  //       <Route path="*" element={<Navigate to="/app" replace />} />
  //     </Routes>
  //   )
  // }

  return (
    <Routes>
      <Route path="/clientlogin" element={<ClientLogin />} />
      <Route
        path="/login"
        element={
          <LoginScreen
            selectedServerUrl={selectedServerUrl}
            onServerChange={onServerChange}
          />
        }
      />
      <Route
        path="/app"
        element={
          <DashboardPrivateRoute
            isLoaderActive={isLoaderActive}
            toggleTheme={toggleTheme}
            increaseFontSize={increaseFontSize}
            decreaseFontSize={decreaseFontSize}
            canIncreaseFontSize={canIncreaseFontSize}
            canDecreaseFontSize={canDecreaseFontSize}
            selectedServerUrl={selectedServerUrl}
            onServerChange={onServerChange}
          >
            <Layout
            isLoaderActive={isLoaderActive}
            toggleTheme={toggleTheme}
            increaseFontSize={increaseFontSize}
            decreaseFontSize={decreaseFontSize}
            canIncreaseFontSize={canIncreaseFontSize}
            canDecreaseFontSize={canDecreaseFontSize}
            selectedServerUrl={selectedServerUrl}
            onServerChange={onServerChange}
          />
          </DashboardPrivateRoute>
        }
      >
        <Route index element={<AppLauncher />} />
        <Route path="kitchen" element={<KitchenTabsScreen />} />
        <Route path="kitchen-stats" element={<KitchenStats />} />
        <Route path="printer" element={<Printer />} />
      </Route>
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  )
}

export { AppRoutes }
